module.exports = __webpack_public_path__ + "img/explain.563e5384.svg";